import styled from 'styled-components'

export const LogosContainer = styled.div`
  text-align: center;
  margin-block-start: 1.4rem;
  padding: 20px;
  span {
    font-family: Sora;
    font-size: 3.5rem;
    color: #fa8c16;
    font-weight: bold;
    padding-block-end: 2rem;
  }

  @media (max-width: 720px) {
    span {
      font-size: 2rem;
    }
  }
`
export const Logo = styled.img`
  max-width: 200px;
  height: 160px;
  margin: 0 20px;
  border-radius: 9.61px;
  background-color: #e6e6e6;
`
